import { ArrowUpRight } from "lucide-react";
import { BRAND } from "@/lib/data";

export default function DeltaPartnership() {
  return (
    <section data-testid="delta-section" className="border-b border-damita-border bg-damita-blue text-white">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10 lg:px-16 py-14 md:py-20">
        <div className="grid grid-cols-12 gap-6 lg:gap-12 items-center">
          {/* Logos block */}
          <div className="col-span-12 lg:col-span-5">
            <div className="font-mono text-[10px] uppercase tracking-[0.22em] text-damita-yellow mb-6">
              / Authorized Business Partner
            </div>
            <div className="grid grid-cols-2 gap-px bg-white/20">
              <div className="bg-white border border-white/20 p-6 md:p-8 flex items-center justify-center min-h-[160px]">
                <img
                  src={BRAND.logo}
                  alt="Bada Biplab Power Solutions"
                  className="max-h-[120px] w-auto object-contain"
                />
              </div>
              <div className="bg-white text-damita-ink border border-white/20 p-6 md:p-8 flex flex-col items-center justify-center min-h-[160px] text-center">
                <div className="font-display font-black text-4xl md:text-5xl tracking-tighter italic" style={{ color: "#1E3A8A" }}>
                  Δelta
                </div>
                <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-damita-ink2 mt-2">
                  Global Partner
                </div>
              </div>
            </div>
            <div className="mt-4 flex items-center gap-3 text-blue-200 text-sm">
              <span className="w-6 h-px bg-white/40" />
              <span className="font-mono text-[10px] uppercase tracking-[0.22em]">
                Strategic Alliance · Since formation
              </span>
            </div>
          </div>

          {/* Copy block */}
          <div className="col-span-12 lg:col-span-7 lg:pl-8 lg:border-l border-white/20">
            <h2 className="font-display font-black text-3xl md:text-4xl lg:text-5xl tracking-tighter leading-[0.95]">
              Authorized partner of <span className="text-damita-yellow">Delta</span> —
              a global leader in switching power supplies &amp; thermal management.
            </h2>
            <p className="mt-6 text-base md:text-lg leading-relaxed text-blue-100 max-w-2xl">
              BB Power is proud to be an Authorized Business Partner of Delta — bringing
              you a comprehensive portfolio of cutting-edge IoT-based power and cooling
              solutions to drive your innovation forward.
            </p>
            <div className="mt-8 flex flex-wrap items-center gap-3 font-mono text-[10px] uppercase tracking-[0.22em]">
              <span className="px-3 py-1.5 border border-white/30 text-blue-100">Switching PSU</span>
              <span className="px-3 py-1.5 border border-white/30 text-blue-100">Thermal Management</span>
              <span className="px-3 py-1.5 border border-white/30 text-blue-100">IoT-Based</span>
              <span className="px-3 py-1.5 border border-white/30 text-blue-100">Data Centre Grade</span>
            </div>
            <a
              data-testid="delta-explore"
              href="/products"
              className="mt-8 inline-flex items-center gap-2 text-damita-yellow font-semibold hover:gap-3 transition-all"
            >
              Explore Delta-grade product range
              <ArrowUpRight size={18} />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
